import React, { useState } from "react";
import "../../styles/submenu.css";
import { withNamespaces } from 'react-i18next';


const Submenu = ({t}) => {

    const [isOpenGeral, setIsOpenGeral] = useState(false);


    const inicialMenu = {
        option1: false,
        option2: false,

    };
    const inicialActive = {
        option1: false,
        option2: false,
    };

    const [menu, setMenu] = useState(inicialMenu);
    const [active, setActive] = useState(inicialActive);
    const toogleMenu = (optionName) => {
        let menu_aux = {};
        let element_active = {};
        for (const key in menu) {
            menu_aux[key] = key === optionName ? !menu[key] : false;
        }
        for (const key in active) {
            element_active[key] = key === optionName ? !menu[key] : false;
        }
        setMenu(menu_aux);
        setActive(element_active);
    };
    
    const collapseOnClickItem = (optionName) => {
        setIsOpenGeral(false);
        toogleMenu(optionName)
    };


    return (
        <nav className="navbar navbar-expand-lg submenu-geral position-sticky overflow auto">
            <div className="container">
                <h3 className="page-title">{t('moduleChegadaAveiro:T')}</h3>
                <button id="chegadaaveiro" onClick={() => setIsOpenGeral(!isOpenGeral)} className="submenu-btn" type="button" data-bs-toggle="collapse" data-bs-target="#chegada-submenu" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <i className={`fas fa-chevron-${isOpenGeral ? 'up' : 'down'}`}></i>
                </button>
                <div className={`collapse navbar-collapse ${isOpenGeral ? 'show' : ''}`} id="chegada-submenu">
                    <ul className="navbar-nav page-subtitles">
                        <li>
                            <a href="#1" className="submenu-link" onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S1.T')}</a>
                        </li>
                        <li>
                            <a href="#2" className="submenu-link" onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S2.T')}</a>
                        </li>
                        <li>
                            <a href="#3" className="submenu-link" onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S3.T')}</a>
                        </li>
                        <li>
                            <a href="#4" className="submenu-link" onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S4.T')}</a>
                        </li>
                        <li>
                            <a href="#5" className={`submenu-link ${active.option1 ? "active" : null}`} onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S5.T')}</a>
                            <button onClick={() => toogleMenu("option1")} className={`arrow-btn-submenu ${active.option1 ? "active" : null}`} type="button" data-bs-toggle="collapse" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <i className={`fas fa-chevron-${menu.option1 ? 'up' : 'down'} fa-xs`}></i>
                            </button>
                            {
                                menu.option1 && (
                                    <ul className="navbar-nav page-subtitles submenu-option">
                                        <li>
                                            <a href="#paco" className="drop-link" onClick={()=>collapseOnClickItem("option1")}>{t('moduleChegadaAveiro:S5.ST1.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#turmas_horarios" className="drop-link" onClick={()=>collapseOnClickItem("option1")}>{t('moduleChegadaAveiro:S5.ST2.ST')}</a>
                                        </li>
                                    </ul>
                                )}
                        </li>

                        <li>
                            <a href="#6" className={`submenu-link ${active.option2 ? "active" : null}`} onClick={() => setIsOpenGeral(false)}>{t('moduleChegadaAveiro:S6.T')}</a>
                            <button onClick={() => toogleMenu("option2")} className={`arrow-btn-submenu ${active.option2 ? "active" : null}`} type="button" data-bs-toggle="collapse" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                <i className={`fas fa-chevron-${menu.option2 ? 'up' : 'down'} fa-xs`}></i>
                            </button>
                            {
                                menu.option2 && (
                                    <ul id="lastDrop" className="navbar-nav page-subtitles submenu-option">
                                        <li>
                                            <a href="#sef" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST1.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#comprovativo_morada" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST2.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#nif" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST3.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#abertura_conta" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST4.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#cartao_estudante" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST5.ST')}</a>
                                        </li>
                                        <li>
                                            <a href="#inscricao_sns" className="drop-link" onClick={()=>collapseOnClickItem("option2")}>{t('moduleChegadaAveiro:S6.ST6.ST')}</a>
                                        </li>
                                    </ul>
                                )}
                        </li>
                    </ul>
                </div>
            </div>
        </nav >
    );
};

export default withNamespaces() (Submenu);
